import React from 'react';
import { ReactComponent as HappyFace } from 'App/assets/img/happy-face.svg';
import { Container } from './SuccessContent.styles';

interface SuccessContentProps {
	alreadyReferred: number;
	success: number;
	error: number;
}

export const SuccessContent = ({
	alreadyReferred,
	success,
	error,
}: SuccessContentProps): JSX.Element => {
	return (
		<Container>
			<HappyFace />
			<p>¡Solicitud creada!</p>
			<ul>
				{alreadyReferred && alreadyReferred !== 0 ? (
					<li>
						Ya referido:
						<strong> {alreadyReferred}</strong>
					</li>
				) : null}
				{success && success !== 0 ? (
					<li>
						Solicitudes exitosas:
						<strong> {success}</strong>
					</li>
				) : null}
				{error && error !== 0 ? (
					<li>
						Solicitudes de errores:
						<strong> {error}</strong>
					</li>
				) : null}
			</ul>
		</Container>
	);
};
